import template from './time_rules.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class TimeRulesSetupViewModel
{
	constructor(page)
	{
		this.page = page;
		this.loader = ko.observable(false);
		this.table_report = ko.observableArray();
		this.download_data = ko.observableArray();
		this.manager = ko.observableArray([]);
		this.employee_id = ko.observable();
		this.department_id = ko.observable();
		this.company_id = ko.observable();
		this.from_filter = ko.observable(Utils.toJSONDateString(new Date(new Date().setFullYear(new Date().getFullYear() - 1))));
		this.to_filter = ko.observable(Utils.toJSONDateString(new Date()));
		this.start_time = ko.observable();
		this.end_time = ko.observable();
		this.overtime_rules = ko.observableArray();

		//options
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);
		this.selected_display = ko.observable('time_logged_rg');
		this.selected_department = ko.observable();
		this.selected_search = ko.observable('employee_rg');
		this.summary_total_hours = ko.observable(0);
		this.summary_employees_count = ko.observable(0);
		this.table_visible = ko.observable(false);
		this.selected_company = ko.observable();
		this.company_id = ko.observable();

		this.selected_company.subscribe((val) => {
			if (val != null)
			{
				this.company_id(val.company_id);
				this.page.load_entries();
			}
			else
				this.company_id(null);
		})

		this.selected_department.subscribe((value) => {
			if (value != null)
			{
				this.department_id(value.department_id);
				this.company_id(value.company_id);
				this.page.load_entries();
			}
			else
			{
				this.department_id(null);
				this.page.load_entries();
			}
		});

		this.selected_number_of_records.subscribe((value) => {
			this.current_page_size(value);
			this.current_page_number(1); // Reset to first page
			this.page.loadTimeRules();
		});
	}

	setNormalWorkingHours(start, end)
	{
		this.start_time(start);
		this.end_time(end);
	}

	async add_time_rule()
	{
		await Grape.dialog.open('AddTimeRules', { 
			department_id: this.department_id(),
			company_id: this.company_id()
		 });
		this.page.load_entries();
	}

	async delete_entry(row)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete the entry?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/time_management/delete_time_rule', {time_rule_id: row.time_rule_id});
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully removed time rule.'), title: tr('Success')});
				this.page.updateData();
			}
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.page.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({type: 'error', message: res.error, title: tr('Error')});
				this.page.updateData();
			}
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
	}

	async edit_entry(row)
	{
		row.department_id = this.department_id();
		await Grape.dialog.open('AddTimeRules', { row: row });
		this.page.load_entries();
	}

	async edit_overtime_rules(row)
	{
		console.log('row data ', row);
		row.company_id = this.company_id();
		row.department_id = this.department_id();
		await Grape.dialog.open('AddOverTimeRules', { row: row });

		this.page.load_overtime_rules();
	}

	async delete_overtime_rules(row)
	{
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete the entry?') });
		if (response)
		{
			let res = await Grape.fetches.postJSON('/time_management/delete_overtime_rule', { overtime_id: row.overtime_id });
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully removed overtime rule.'), title: tr('Success') });
				this.page.updateData();
			}
			else
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error') });	
		}
	}

	show_time_rules_help()
	{
		Grape.dialog.open('SetupTimeRulesHelp', { employee_id: this.page.bindings.id });
	}

	show_overtime_rules_help()
	{
		Grape.dialog.open('SetupOvertimeRulesHelp', { employee_id: this.page.bindings.id });
	}
	async add_overtime_rules()
	{
		console.log('company id ', this.company_id());
		await Grape.dialog.open('AddOverTimeRules', { department_id: this.department_id(), company_id: this.company_id() });
		this.page.updateData();
	}

	format_workdays(workdays)
	{
		if (typeof workdays === 'string')
		{
			return workdays.replace(/[{}]/g, '').split(',').map(day => day.trim()).join(', ');
		}
		return workdays;
	}

	page_click (page_number)
	{
		
		this.current_page_number(page_number);
		this.page.loadTimeRules();
	};
}

class TimeRulesSetupPage 
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new TimeRulesSetupViewModel(this);
		this.eventsArray = {
			'click .edit_entry': (e, value, row, index) => {
				this.viewModel.edit_entry(row);
			},
			'click .delete_entry': (e, value, row, index) => {
				this.viewModel.delete_entry(row);
			},
		};
	}

	init()
	{
		document.title = tr('Setup Time Rules');
		window.current_page_title(tr('Setup Time Rules'));
		this.viewModel.employee_id(Utils.current_employee_id());
	}

	updateData()
	{
		this.load_entries();
	}

	async load_entries()
	{
		this.viewModel.loader(true);
		this.viewModel.table_visible(false);
		this.viewModel.loader(false);
		await this.loadTimeRules();
		await this.load_overtime_rules();
	}

	async loadTimeRules()
	{
		if (!this.viewModel.company_id()) return;
		
		let filters = [
			{
				field: 'active',
				operand: '=',
				value: 'true'
			},
			{
				field: 'company_id',
				operand: '=',
				value: this.viewModel.company_id()
			}
		];
		
		// Only add department filter if a department is selected
		if (this.viewModel.department_id()) {
			filters.push({
				field: 'department_id',
				operand: '=',
				value: this.viewModel.department_id()
			});
		}
		
		let table_query_options = {
			table: 'v_time_rules',
			schema: 'savanna',
			sortfield: 'employee_id',
			sortorder: 'ASC',
			offset: (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size(),
			limit: this.viewModel.current_page_size(),
			filter: filters,
			count: true
		};
	
		console.log('Query options:', table_query_options);
		
		let res = await Grape.fetches.getJSON('/api/record', table_query_options);
		console.log('result', res)
		
		if (res.status !== 'ERROR' && res.records && res.records.length > 0)
		{
			this.viewModel.table_visible(true);
			this.viewModel.table_report(res.records);
			
			let totalRecords = res.count || res.total || res.records.length;
			this.viewModel.page_count(Math.ceil(totalRecords / this.viewModel.current_page_size()));
			
			let startRecord = (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size() + 1;
			let endRecord = Math.min(this.viewModel.current_page_number() * this.viewModel.current_page_size(), totalRecords);
			
			this.viewModel.pagination_summary(`Showing ${startRecord}-${endRecord} of ${totalRecords} records (Page ${this.viewModel.current_page_number()} of ${this.viewModel.page_count()})`);
		}
		else
		{
			this.viewModel.page_count(0);
			this.viewModel.pagination_summary('No time rules found.');
			this.viewModel.table_visible(false);
			this.viewModel.table_report([]);
		}
	}

	async load_overtime_rules()
	{
	    if (!this.viewModel.company_id()) return;

	    let filters = [
	        {
	            field: 'company_id',
	            operand: '=',
	            value: this.viewModel.company_id()
	        }
	    ];

	    if (this.viewModel.department_id())
	    {
	        filters.push({
	            field: 'department_id',
	            operand: '=',
	            value: this.viewModel.department_id()
	        });
	    }

	    let options = {
	        table: 'v_overtime_rules',
	        schema: 'savanna',
	        filter: filters
	    };

	    let res = await Grape.fetches.getJSON('/api/record', options);

	    if (res.status !== 'ERROR')
	        this.viewModel.overtime_rules(res.records || []);
	    else
	        this.viewModel.overtime_rules([]);
	}

	set_table_query_options()
	{
		let table_query_options = {
			offset: 0,
			limit: 1000000000,
			department_id: this.viewModel.department_id(),
			company_id: this.viewModel.company_id(),
			where: "active = true",
		}
		return table_query_options;
	}
}

export default {
	route: '[/]time_management/time_rules_setup',
	page_class: TimeRulesSetupPage,
	template: template,
	template_filename: 'translation/time_rules',
};
